import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePageTitle } from "../../hooks/usePageTitle";

export function Dashboard() {
  usePageTitle("Admin Dashboard");
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await fetch("/api/admin/stats");
      if (response.ok) {
        const data = await response.json();
        setStats(data);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-8">Dashboard</h1>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-gray-600 text-sm mb-2">Total Orders</h3>
          <p className="text-3xl font-bold">{stats?.total_orders || 0}</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-gray-600 text-sm mb-2">Total Revenue</h3>
          <p className="text-3xl font-bold">
            ${(stats?.total_revenue || 0).toFixed(2)}
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-gray-600 text-sm mb-2">Pending Orders</h3>
          <p className="text-3xl font-bold">{stats?.pending_orders || 0}</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-gray-600 text-sm mb-2">Today's Orders</h3>
          <p className="text-3xl font-bold">{stats?.today_orders || 0}</p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">Quick Actions</h2>
          <div className="space-y-2">
            <Link
              to="/admin/products"
              className="block px-4 py-2 bg-black text-white rounded hover:bg-gray-800 text-center"
            >
              Manage Products
            </Link>
            <Link
              to="/admin/orders"
              className="block px-4 py-2 bg-black text-white rounded hover:bg-gray-800 text-center"
            >
              View Orders
            </Link>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">System Info</h2>
          <div className="space-y-2 text-sm">
            <p>
              <span className="text-gray-600">Database:</span> SQLite
            </p>
            <p>
              <span className="text-gray-600">Runtime:</span> Bun
            </p>
            <p>
              <span className="text-gray-600">Frontend:</span> React 19
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
